import React, {useEffect, useState} from "react";
import Grid from "@material-ui/core/Grid";
import FormControl from "@material-ui/core/FormControl";
import {CircularProgress, InputLabel, Select} from "@material-ui/core";
import MenuItem from "@material-ui/core/MenuItem";
import Button from "@material-ui/core/Button";

const UserSelectionPanel = ({course,user,setUser,setActiveStep}) => {
    const [users,setUsers] = useState([])
    const [loading,setLoading] = useState(false)

    const fetchUsers = async () => {
        setLoading(true);
        let sessionId=sessionStorage.getItem("sessionId");
        let headers= new Headers({
            'Authorization':'Bearer '+sessionId
        });
        const users= await fetch(`/interactions-api/course/${course}/users`,{ headers: headers })
            .then(r => r.json())
            .catch(reason => {
                console.log(reason);
                return [
                    {
                        id: "CourseId1",
                        name: "Asignatura1"
                    },
                    {
                        id: "CourseId2",
                        name: "Asignatura2"
                    }
                ];
            });
        setUsers(users);
        setLoading(false);
    }

    useEffect(() =>{
        fetchUsers(users)
    },[])

    return (
        <React.Fragment>
            <Grid container
                  spacing={3}
                  alignItems={"center"}
                  justify={"space-around"}
                  style={{padding:"10px"}}>
                { loading === true &&
                    <CircularProgress />
                }
                { loading === false &&
                    <React.Fragment>
                        <Grid item lg={12}>
                            <FormControl variant={"standard"} fullWidth>
                                <InputLabel id={"UserSelectLabel"}>
                                    Usuario
                                </InputLabel>
                                <Select labelId={"UserSelectLabel"}
                                        id={"UserSelect"}
                                        value={user} onChange={(event => {setUser(event.target.value)})}>
                                    { users.map(value => {
                                        return (
                                            <MenuItem key={value.externalId} value={value.externalId}>{value.name}</MenuItem>
                                        )
                                    })}
                                </Select>
                            </FormControl>
                        </Grid>
                        <Grid item lg>
                            <Button variant={"contained"}
                                    color={"default"}
                                    fullWidth
                                    onClick={()=>{setActiveStep(1)}}>
                                Atras
                            </Button>
                        </Grid>
                        <Grid item lg>
                            <Button variant={"contained"}
                                    color={"primary"}
                                    fullWidth
                                    onClick={()=>{setActiveStep(3)}}>
                                Seleccionar
                            </Button>
                        </Grid>
                    </React.Fragment>
                }
            </Grid>
        </React.Fragment>
    )
}

export default UserSelectionPanel